export default {
      id: "tiktok-usage",
      viewBox: "0 0 1430 1672",
      url: "../../assets/" + "sprite.svg#tiktok-usage",
      toString: function () {
        return this.url;
      }
    }